import React from "react";
import { Helmet } from "react-helmet";
// import { Link } from "react-router-dom";
import Phone from "../../components/Shared/Phone"
const classes = require('./WineDinner.module.scss');
// const image1 = require('../../assets/images/mmExt1.jpg');

const wineDinner = () => {
  return (
    <div className={classes.WineDinner}>
      <Helmet>
        <title>Waterfront Wine Dinners at Mile Marker 158 Dockside</title>
        <meta name="description" content="Check out the next wine pairing at Mile Marker 158 Dockside, located at The Wharf in Orange Beach, Alabama." />
      </Helmet>

      <div className={classes.medDef}>
        <div className={classes.menuArea}>
          <div className={classes.inside}>
            <div className={classes.titleRow}>
              <div className={classes.inner}>
                <h1>January Wine Dinner</h1>
                <h2>
                  January 24 <br className={classes.br1}/>
                  <span className={classes.sp1}>&nbsp;|&nbsp;</span> 6pm <span className={classes.sp2}>&nbsp;|&nbsp;</span> $50 Per Guest
                </h2>
                <h3>Hosted by United Johnson Brothers</h3>
                <h4>For Reservations: <Phone where="wineDinner" /></h4>
              </div>
            </div>
          </div>

          <div className={[classes.inside, classes.stip].join(' ')}>
            <div className={classes.menuRow}>
              <div className={classes.menuBoxFull}>
              {/* &middot; */}
                <h5>First Course</h5>
                <h4>SHRIMP FRITTERS</h4>
                <p>Corn, Bell Pepper, Onion, Orange Marmalade Dipping Sauce</p>
                <p className={classes.pair}>Paired With</p>
                <h4>Harvey &amp; Harriet White Blend &middot; Paso Robles, CA</h4>
              </div>
              
              <div className={classes.menuBoxFull}>
                <h5>Second Course </h5>
                <h4>BAKED BRIE &amp; BACON WRAPPED DATES</h4>
                <p>Pecan Encrusted Baked Brie, Fig Honey, Garlic Crostini</p>
                <p className={classes.pair}>Paired With</p>
                <h4>Terrazas de los Andes Reserva Chardonnay &middot; Mendoza, Argentina</h4>
              </div>

              <div className={classes.menuBoxFull}>
                <h5>Third Course</h5>
                <h4>MAPLE GLAZED SALMON</h4>
                <p>Sautéed Leeks, Shiitake Mushrooms, Spinach, Scallions, Roasted Fingerling Potatoes</p>
                <p className={classes.pair}>Paired With</p>
                <h4>Stemmari Cantadoro Sicilia DOC &middot; Sicily, Italy</h4>
              </div>

              <div className={classes.menuBoxFull}>
                <h5>Fourth Course</h5>
                <h4>CHOCOLATE CREME BRULEE</h4>
                <p>Fresh Berries, Whipped Cream</p>
                <p className={classes.pair}>Paired With</p>
                <h4>Sella Antica &middot; Tuscany, Italy</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default wineDinner;